import React from 'react';
import { Flex } from '@chakra-ui/react';
import DashboardHeader from './DashboardHeader';
import ChatInput from './ChatInput';
import { useChatStore } from '../store/chatStore';
import { useVehicleStore } from '../store/vehicleStore';

const Dashboard = ({
  onChatSubmit,
}) => {
  // Zustand stores
  const { inputValue, setInputValue, isLoading } = useChatStore();
  const { selectedVehicleConversationId } = useVehicleStore();

  const handleChatSubmit = value => {
    if (value.trim() && !isLoading) {
      onChatSubmit(value);
      setInputValue(''); // Clear input after submission
    }
  };

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      minH="calc(100vh - 80px)"
      px={6}
      py={8}
      w="full"
      maxW="100%"
    >
      <DashboardHeader />

      <ChatInput
        inputValue={inputValue}
        setInputValue={setInputValue}
        isLoading={isLoading}
        onSubmit={handleChatSubmit}
        placeholder={
          selectedVehicleConversationId
            ? 'Ask anything about your vehicle...'
            : 'Start a new conversation about your vehicle...'
        }
      />
    </Flex>
  );
};

export default Dashboard;
